import misRutas from 'vue-routes-generator'
import GestionEmailComponent from './app'

export default {
	install: Vue => {
		misRutas.route('/main').child('panel-control').child('gestion-cuentas-email', {
			name: 'Gestión de cuentas de e-mail',
			component: GestionEmailComponent
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-cuentas-email/vue/index.js